import * as React from "react";
const RightBubble = (props) => (
  <svg
    width={139}
    height={129}
    viewBox="0 0 139 129"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M149.82 -113.345C140.644 -121.868 131.693 -130.181 120.646 -127.482C109.839 -124.841 104.973 -114.107 99.9892 -103.114C95.8562 -94 91.6432 -84.7076 83.8972 -79.7011C77.2522 -75.4058 68.5647 -76.0986 60.0059 -76.7812C50.3788 -77.549 40.914 -78.3038 34.6992 -71.9323C28.2397 -65.3099 29.3042 -55.6631 30.3966 -45.7627C31.2194 -38.3067 32.058 -30.7067 29.7104 -24.1477C27.0464 -16.7037 20.9092 -10.3567 14.9002 -4.14266C6.42503 4.62134 -1.79527 13.1223 0.343126 24.0663C2.71593 36.2093 13.0388 38.1033 24.3583 40.1793C33.9292 41.9353 44.2126 43.8213 51.0055 52.1443C56.8485 59.3033 57.5851 67.3993 58.3828 76.1673C59.2441 85.6343 60.1766 95.8833 67.6863 106.58C78.8022 122.413 101.303 128.814 120.646 128.481C155.983 127.872 183.503 103.477 209.722 69.9773C235.941 36.4773 240.435 6.47733 231.656 -28.7297C220.883 -71.9323 207.722 -81.0227 167.198 -100.058C160.983 -102.977 155.36 -108.199 149.82 -113.345ZM75.4602 -108.901C75.4602 -99.1683 69.5012 -91.2786 62.1496 -91.2786C54.7985 -91.2786 48.8393 -99.1683 48.8393 -108.901C48.8393 -118.633 54.7985 -126.523 62.1496 -126.523C69.5012 -126.523 75.4602 -118.633 75.4602 -108.901Z"
      fill="#F5EBF4"
    />
  </svg>
);
export default RightBubble;
